import React, { useState, useEffect } from "react";
import { apiRequest } from "../../../hooks/apiRequest";
import Loader from "../../general/Loader";
import { formatCurrency, getLink } from "../../../utils/helpers";
import { Link } from "react-router-dom";

const Nominas = ({ empleado }) => {
    const [pagos, setPagos] = useState([]);
    const [comisiones, setComisiones] = useState([]);
    const [loading, setLoading] = useState(true);
    const [nominasOpen, setNominasOpen] = useState(true);
    const [pagosExtraOpen, setPagosExtraOpen] = useState(true);

    useEffect(() => {
        const id = empleado.id;

        apiRequest(null, `empleados/${id}/pagos`, "get").then((res) => {
            if (res?.success) {
                setPagos(res.data);
                setLoading(false);
            }
        });

        apiRequest(null, `empleados/${id}/comisiones`, "get").then((res) => {
            if (res?.success) {
                setComisiones(res.data);
            }
        });
    }, [empleado.id]);

    if (loading) {
        return <Loader />;
    }

    return (
        <div>
            <div className='row m-b-20'>
                <div className='col'>
                    <h3>Historial de Pagos</h3>
                </div>
                <div className='col text-right'>
                    <Link
                        to={getLink(`/imprimir/empleados/${empleado.id}/nominas`)}
                        target="_blank"
                        title="Imprimir"
                        className='au-btn au-btn-icon au-btn-filter'>
                        <i className="zmdi zmdi-print"></i>
                        Imprimir
                    </Link>
                </div>
            </div>
            <h4
                onClick={() => setNominasOpen(o => !o)}
                style={{ cursor: "pointer", userSelect: "none" }}>
                Nóminas
                <i className={`zmdi zmdi-chevron-${nominasOpen ? "up" : "down"} ml-2`}></i>
            </h4>
            {nominasOpen && (
                <table className='table tickets-table'>
                    <thead>
                        <tr>
                            <th>Fecha</th>
                            <th>Sueldo Fijo</th>
                            <th>Descuentos</th>
                            <th>Incentivos Fijos</th>
                            <th>Incentivos Únicos</th>
                            <th className="text-right">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pagos.map((pago, index) => (
                            <tr key={index}>
                                <td>{pago.fecha}</td>
                                <td>{formatCurrency(pago.sueldoBruto)}</td>
                                <td>{formatCurrency(pago.descuentosTotal)}</td>
                                <td>{formatCurrency(pago.incentivosFijos)}</td>
                                <td>{formatCurrency(pago.incentivosUnicos)}</td>
                                <td className="text-right">{formatCurrency(pago.total)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
            {comisiones.length > 0 && (
                <>
                    <h4
                        className="mt-5"
                        onClick={() => setPagosExtraOpen(o => !o)}
                        style={{ cursor: "pointer", userSelect: "none" }}>
                        Pagos Extra
                        <i className={`zmdi zmdi-chevron-${pagosExtraOpen ? "up" : "down"} ml-2`}></i>
                    </h4>
                    {pagosExtraOpen && (
                        <table className='table tickets-table'>
                            <thead>
                                <tr>
                                    <th>Fecha</th>
                                    <th>Tipo</th>
                                    <th>Nómina</th>
                                    <th>Rango de Fechas</th>
                                    <th>Detalles</th>
                                    <th className="text-right">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {comisiones.map((comision, index) => (
                                    <tr key={index}>
                                        <td>{comision.fecha}</td>
                                        <td>{comision.tipo}</td>
                                        <td>{comision.nomina}</td>
                                        <td>{comision.desde} hasta {comision.hasta}</td>
                                        <td style={{lineHeight: 1.2}}>{comision.detalles?.categorias?.map(cat => {
                                                const categoria = comision.categorias.find(c => c.id == cat.id);
                                                return (
                                                    <div>{categoria?.nombre} - {cat.porcentaje}%</div>
                                                )
                                            })}
                                            {comision.porciento_comision > 0 && (
                                                <div>COMISIÓN: {comision.porciento_comision}%</div>
                                            )}
                                        </td>
                                        <td className="text-right">{formatCurrency(comision.total)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </>
            )}
        </div>
    );
};

export default Nominas;
